import { useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "../../lib/supabase";
import stampImg from "../../img/stampp.png";
import signImg from "../../img/sign.png";

export default function CertificateVerification() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();

const type = searchParams.get("type") || "certificate";
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadStudent();
  }, [id]);

  const loadStudent = async () => {
    try {
      const { data, error } = await supabase
        .from("students")
        .select("*")
        .eq("id", id)
        .single();

      if (error) throw error;

      setStudent(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-xl font-bold">
        Loading Certificate...
      </div>
    );
  }

  if (!student) {
    return (
      <div className="h-screen flex items-center justify-center text-red-500 font-bold">
        Certificate Not Found
      </div>
    );
  }

  const relationPrefix =
    student.gender?.toLowerCase() === "male"
      ? "S/o"
      : student.gender?.toLowerCase() === "female"
      ? "D/o"
      : "Child of";

  const modules = student.module_data || [];

  const totalSecured = modules.reduce(
    (sum, module) => sum + (parseInt(module.marks) || 0),
    0
  );

  const totalPossible = modules.length * 100;

  const percentage =
    totalPossible > 0
      ? ((totalSecured / totalPossible) * 100).toFixed(2)
      : 0;

  return (
    <>
      <style>
        {`
          @media print {
            .print-btn {
              display:none !important;
            }

            body {
              background:white !important;
            }

            .certificate-container {
              box-shadow:none !important;
              margin:0 !important;
              max-width:100% !important;
            }
          }
        `}
      </style>

      <div className="min-h-screen bg-slate-200 py-10 px-4">
        {/* Print Button */}
       

        <div
          className="certificate-container max-w-6xl mx-auto bg-[#fffdf0] relative shadow-2xl"
          style={{
            border: "6px double #8b5e3c",
            padding: "40px",
          }}
        >
          {/* Watermark */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%) rotate(-30deg)",
              fontSize: "60px",
              opacity: 0.03,
              fontWeight: "bold",
              textAlign: "center",
              pointerEvents: "none",
              zIndex: 0,
            }}
          >
            DIVYA TECHNICAL INSTITUTE
            <br />
            DIVYA TECHNICAL INSTITUTE
            <br />
            DIVYA TECHNICAL INSTITUTE
          </div>

          {/* Header */}
          <div className="relative z-10 text-center">
            <div className="flex justify-between text-xs font-bold text-[#7c2d12]">
              <span>Run by BSSST</span>
              <span>Reg.No. IN-UP58033026783122W</span>
            </div>

            <h1 className="text-4xl font-black text-[#7c2d12] mt-3">
              DIVYA TECHNICAL INSTITUTE
            </h1>

            <div className="inline-block bg-orange-500 text-white px-6 py-2 rounded-full mt-4 font-bold">
              Certificate Verified ✅
            </div>

            <p className="mt-3 text-sm font-bold text-slate-600">
              Vill.+Post Mardah, Distt. Ghazipur (U.P.) — 233226
            </p>
          </div>

          {/* Photo */}
          <div className="absolute top-36 left-10 z-10">
            {student.photo_url ? (
              <img
                src={student.photo_url}
                alt={student.full_name}
                className="w-28 h-36 object-cover border-2 border-[#8b5e3c]"
              />
            ) : (
              <div className="w-28 h-36 border-2 border-[#8b5e3c] flex items-center justify-center text-xs">
                PHOTO
              </div>
            )}
          </div>

          {/* Certificate */}
          <div className="relative z-10 mt-16 md:ml-40 text-center">
            <p className="italic text-lg">
              This is to certify that
            </p>

            <h2 className="text-4xl font-bold text-blue-700 my-5 uppercase">
              {student.full_name}
            </h2>

            <p className="italic text-lg">
              {relationPrefix}{" "}
              <span className="font-bold text-blue-700">
                {student.parent_name}
              </span>
            </p>

            <p className="text-xl md:text-2xl italic mt-8 leading-loose">
              has been awarded the{" "}
              <span className="text-orange-600 font-bold">
                {student.issued_course_name || student.course_name}
              </span>{" "}
              diploma having successfully completed the prescribed curriculum
              from our center with grade{" "}
              <span className="text-blue-700 font-bold">
                {student.grade}
              </span>
            </p>

            <p className="mt-8 text-lg font-bold">
              Certificate issued on :{" "}
              {student.completion_date}
            </p>
          </div>

          {/* Details */}
          <div className="relative z-10 mt-10 flex flex-col md:flex-row justify-between gap-3 font-bold border-b pb-4">
            <span>
              Certificate No : {student.certificate_no}
            </span>

            <span>
              Roll No : {student.roll_no}
            </span>
          </div>

          {/* Marksheet */}
          {type === "both" && modules.length > 0 && (
            <div className="relative z-10 mt-12">
              <h2 className="text-center text-2xl font-bold text-[#7c2d12] mb-6">
                Academic Marksheet
              </h2>

              <div className="overflow-x-auto">
                <table className="w-full border-collapse border-2 border-black">
                  <thead>
                    <tr className="bg-[#7c2d12] text-white">
                      <th className="border p-3 text-left">
                        Module / Subject
                      </th>
                      <th className="border p-3 text-center">
                        Max Marks
                      </th>
                      <th className="border p-3 text-center">
                        Secured
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {modules.map((module, index) => (
                      <tr key={index}>
                        <td className="border p-3">
                          {module.name}
                        </td>

                        <td className="border p-3 text-center">
                          100
                        </td>

                        <td className="border p-3 text-center font-bold">
                          {module.marks}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-xl p-6">
                <div className="grid md:grid-cols-2 gap-4 font-semibold">
                  <p>
                    Total Secured :
                    <span className="ml-2 text-[#7c2d12]">
                      {totalSecured} / {totalPossible}
                    </span>
                  </p>

                  <p>
                    Percentage :
                    <span className="ml-2 text-[#7c2d12]">
                      {percentage}%
                    </span>
                  </p>

                  <p>
                    Result Status :
                    <span className="ml-2 text-green-600">
                      PASS
                    </span>
                  </p>

                  <p>
                    Grade :
                    <span className="ml-2 text-blue-700">
                      {student.grade}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Verified */}
          <div className="relative z-10 mt-10 text-center">
            <div className="text-green-600 text-4xl font-bold">
              VERIFIED ✓
            </div>

            <p className="text-slate-500 mt-2">
              This certificate has been verified from the
              official records of Divya Technical Institute.
            </p>
          </div>

          {/* Footer */}
          <div className="relative z-10 flex justify-between items-end mt-20">
            <div className="text-center">
              <img
                src={stampImg}
                className="w-24"
                alt="Stamp"
              />
            </div>

            <div className="text-center">
              <img
                src={signImg}
                className="w-40 mx-auto"
                alt="Signature"
              />

              <div className="border-t-2 border-black pt-2 font-bold">
                Santosh Kumar Prajapati
              </div>

              <div>(Director)</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}